export const testimonials = [
  {
    who: 'Maya & Jordan',
    years: 'married 6 yrs',
    quote: '"We thought we knew everything about each other after six years. Turns out there were dozens of things we both wanted but never said out loud."',
  },
  {
    who: 'Priya & Sam',
    years: 'together 2 yrs',
    quote: '"The dares started as a joke on date night. Three months later it\'s our favorite ritual — we literally fight over whose turn it is to pick the heat level."',
  },
  {
    who: 'Alex & Ren',
    years: 'long distance 1 yr',
    quote: '"Being 6,000 miles apart is hard. LuvLust gave us something to DO together, not just talk about. The stories are surprisingly intimate over FaceTime."',
  },
];
